// SEAM: single import site for router primitives. Only this file (+ navigate.ts,
// AppNavigate.tsx, entry/config) changes on a version bump. App code imports from
// 'shared/routing', never from 'react-router' directly.
export {
  Route,
  Routes,
  Link,
  NavLink,
  Outlet,
  useLocation,
  useParams,
  matchPath,
  generatePath,
} from 'react-router'
export type { RouteProps } from 'react-router'
export {
  useAppNavigate,
  useAppParams,
  useAppLocation,
  useAppMatch,
} from './hooks'
export type { To, NavigateOptions, AppNavigateFn } from './hooks'
export { AppNavigate } from './AppNavigate'
export { navigate, registerNavigate } from './navigate'
export { NavigationBridge } from './NavigationBridge'
export { ROUTES } from './paths'
